import { put, takeEvery } from "redux-saga/effects";
import { typeList } from "../../models/Template";
import {
    DeleteTemplate,
    DeleteTemplateComplete,
    DeleteTemplateFailed,
    GetTemplate,
    GetTemplatesComplete,
    RenameTemplate,
    RenameTemplateComplete,
    UpdateTemplate,
    UpdateTemplateComplete,
} from "../actions/TemplateActions";
import TemplateApi from "../apis/TemplateApi";
import TemplateEvents from "../events/TemplateEvents";

// テンプレート更新
function* UpdateTemplateWorker({
    templateFile,
    templateId,
    templateName,
    templateType,
    userId,
}: ReturnType<typeof UpdateTemplate>) {
    yield TemplateApi.updateTemplate(templateFile, templateId, templateName, templateType, userId);
    const updateTemplatelist: any = yield TemplateApi.getTemplates(typeList);
    yield put(UpdateTemplateComplete(updateTemplatelist.templateList));
}

// テンプレート削除
function* DeleteTemplateWorker({
    templateId,
    userId,
    typeList,
}: ReturnType<typeof DeleteTemplate>) {
    const result: any = yield TemplateApi.deleteTemplate(templateId, userId);
    const DelTemplatelist: any = yield TemplateApi.getTemplates(typeList);
    if (result.data && result.data.message) {
        yield put(DeleteTemplateFailed(DelTemplatelist.templateList, result.data.message));
    } else {
        yield put(DeleteTemplateComplete(DelTemplatelist.templateList));
    }
}

// テンプレート名変更
function* RenameTemplateWorker({ id, name, userId }: ReturnType<typeof RenameTemplate>) {
    const templatelist: any = yield TemplateApi.renameTemplate(id, name, userId);
    yield put(RenameTemplateComplete(templatelist.templateList));
}

// テンプレート一覧取得
function* GetTemplateWorker({ typeList }: ReturnType<typeof GetTemplate>) {
    const templatelist: any = yield TemplateApi.getTemplates(typeList);
    yield put(GetTemplatesComplete(templatelist.templateList));
}

export default function* TemplateSaga() {
    yield takeEvery(TemplateEvents.UpdateTemplateStarted, UpdateTemplateWorker);
    yield takeEvery(TemplateEvents.DeleteTemplateStarted, DeleteTemplateWorker);
    yield takeEvery(TemplateEvents.RenameTemplateStarted, RenameTemplateWorker);
    yield takeEvery(TemplateEvents.GetTemplatesStarted, GetTemplateWorker);
}
